let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7TRGL"), load("df12q")]).then(() => parcelRequire('krs8y'));